<template>
  <div class="chell">
    <div class="template-wrapper borderBind" v-bind:style="{background : getColor()}">
      <!--      <span class="font-semibold">-->
      <!--        {{getPracticeName()}}-->
      <!--          <span v-bind:class="{ 'bg-primary' : getType() === 'powder', 'bg-warning' : getType() === 'liquid' }"-->
      <!--                class="blur-lg inline-flex items-center justify-center px-2 py-1 text-xs font-normal leading-none text-white rounded">-->
      <!--            {{getType()}}-->
      <!--          </span>-->
      <!--      </span>-->
      <!--      <br>-->
      <!--      {{getName()}}-->
      <b> {{ getName() }} </b> <br> {{ momentFormat(data.StartTime, 'HH:mm') }}h - {{ momentFormat(data.EndTime, 'HH:mm') }}h
      <br>
      {{ data.status ? data.status.name : '' }}
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: "resourceHeaderTemplate",
    data() {
      return {
        data: '',
        styleObject: {
          background: ''
        }
      }
    },
    methods: {
      getPracticeName() {
        const value = JSON.parse(JSON.stringify(this.data));
        return value.resourceData.text
      },
      getName() {
        const value = JSON.parse(JSON.stringify(this.data));
        return value.Subject
      },
      getType() {
        const value = JSON.parse(JSON.stringify(this.data));
        return value.resourceData.production_line_type
      },
      momentFormat(value, args) {
        return value ? moment(value).format(args) : '';
      },
      getColor: function () {
        if(this.data.status) {
          switch (this.data.status.name) {
            case 'Stopped':
              return '#F85C70';
            case 'Pack Off Completed':
              return '#1DC690';
            case 'Mix Completed':
              return '#1DC690';
            default:
              return '#746C70';
          }
        } else {
          if(this.data.clean_time_data.actual_end_clean_time && this.data.clean_time_data.actual_start_clean_time) {
            return '#1DC690';
          } else {
            return '#746C70';
          }
        }

      }
    },
    watch: {},
  }
</script>

<style scoped>
  .chell {
    width: 100% !important;
    padding-left: 0px;
  }

  .template-wrapper {
    padding: 10px;
    height: 100%;
    font-size: 12px;
  }

  .borderBind {
    border-style: none;
    background-color: transparent;
    border-radius: 1em;
  }
</style>
